<template>
  <div class="c-input-group">
    <div
      class="c-input"
      :class="{ 'c-input--error': isError, 'c-input--success': isSuccess }"
      :data-at-c-input-error="isError"
      @mouseenter="hovering = true"
      @mouseleave="hovering = false"
    >
      <div
        v-if="isLoading"
        class="c-input__loader-container"
      >
        <loader />
      </div>
      <span
        v-if="showClear && showClearButton"
        ref="clear"
        class="c-input__clear"
        @click="onClear"
      ><sprite
        src="sprite_cross-smooth"
      /></span>
      <input
        :id="id"
        ref="input"
        v-model="localValue"
        v-mask="mask"
        class="c-input__input"
        :readonly="readonly"
        :placeholder="placeholder"
        :type="type"
        :data-tid="dataTid"
        :checked="checked"
        data-at-c-input
        @input="onInput($event.target.value)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        @keydown="onKeyDown($event)"
        @change="onChange($event)"
        @click="onClick($event)"
        @keyup="onKeyUp($event)"
      >
      <label
        class="c-input__label"
        :class="type"
        :for="id"
        @click="el.focus()"
      >
        <slot name="icon"><span class="c-input__label-icon" /></slot>
        {{ labelText }}
        <span
          v-if="requiredField"
          class="required-indicator"
        >*</span>
      </label>
    </div>
    <div class="c-input__error-text">
      <slot name="errors" />
    </div>
  </div>
</template>

<script>
// import { required } from 'vuelidate/lib/validators'
import Loader from '@/components/core/ui/Loader'

export default {
  name: 'BaseInput',
  components: {
    Loader,
  },
  props: {
    mask: {
      type: String,
      default: '',
    },
    dataTid: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    showErrors: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: String,
      default: 'Ошибка в поле',
    },
    showClearButton: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default () {
        return 'text'
      },
    },
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Input placeholder',
    },
    labelText: {
      type: String,
      default: 'Input label',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    /**
     * Simple validation object:
     * {
     *  required,
     *  format: input => /\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}/.test(input)
     * }
     */
    v: {
      type: Object,
      default () {
        return null
      },
    },
    requiredField: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'click', 'focus', 'keydown', 'blur', 'change', 'keyup'],
  data () {
    return {
      hovering: false,
      focused: false,
      localValue: '',
    }
  },
  computed: {
    /**
     * Свойство, для получения инпута из вне
     */
    el () {
      return this.$refs.input
    },
    isError () {
      return this.v ? this.v.$error : false
    },
    isSuccess () {
      return this.v ? !this.v.$invalid && !this.hovering && this.value : false
    },
    showClear () {
      // return (((this.clearable && this.value && (this.focused || this.hovering)) || this.isError) && this.input && this.value !== '+7 (')
      return (
        ((!(this.isSuccess && this.focused) &&
          (this.focused || (this.hovering && this.value))) ||
          this.isError) &&
        !this.readonly &&
        this.type !== 'radio'
      )
    },
    getClearButton () {
      return this.$refs.clear
    },
    input: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  mounted () {},
  methods: {
    onClear () {
      // Костыль для номера телефона
      this.$emit(
        'input',
        this.value && this.value.includes('+7 (') ? '+7 (' : '',
      )
      this.el.focus()
    },
    onClick (event) {
      this.$emit('click', event)
    },
    onFocus (event) {
      this.focused = true
      this.$emit('focus', event)
    },
    onKeyDown (event) {
      this.$emit('keydown', event)
    },
    onInput (value) {
      this.$emit('input', value)
    },
    onBlur (event) {
      this.focused = false
      if (this.v) {
        if (!this.value || this.value === '+7 (') {
          this.v.$reset() // хз по ссылке так делать
        } else {
          this.v.$touch()
        }
      }
      this.$emit('blur', event)
    },
    onChange (event) {
      this.$emit('change', event)
    },
    onKeyUp (event) {
      this.$emit('keyup', event)
    },
    onFocusOut () {
      this.onBlur()
    },
  },
}
</script>

<style lang="scss">
// @import 'src/assets/styles/new/misc/core-variables';

.c-input {
  position: relative;
}

.c-input__clear {
  position: absolute;
  color: #4a4a4a;
  background-color: map-get($colors, 'white');
  z-index: 2;
  cursor: pointer;
  bottom: 0.02rem;
  right: 0.012rem;
  padding: 0.08rem;
  border-radius: 0.06rem;

  .c-icon {
    width: 0.1rem;
    height: 0.1rem;
  }

  .c-input--error & {
    color: #e32c2b;
  }
}

.c-input__loader {
  display: block;
  position: absolute;
  top: calc(50% - 0.12rem);
  right: 0.1rem;
  // background-image: url($icon-path+'icons/loader-circle-big.svg');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transition: all 0.3s;
  min-height: 0.24rem;
  min-width: 0.24rem;
  animation: spin 3s linear infinite;
  animation-delay: 0.3s;
  z-index: 10;
}

.c-input__success {
  position: absolute;
  bottom: 0.02rem;
  background-color: map-get($colors, 'white');
  right: 0.02rem;
  z-index: 2;
  padding: 0.08rem;
  color: map-get($colors, 'default-darken');
  border-radius: 0.06rem;

  .c-icon-success {
    width: 0.12rem;
    height: 0.09rem;
  }
}

.c-input__input {
  display: block;
  width: 100%;
  font-size: 0.16rem;
  height: 0.45rem;
  padding: 0.2rem 0.15rem 0.1rem;
  border: 1px solid #bdbdbd;
  border-radius: 0.03rem;
  margin-bottom: 0.04rem;
  font-weight: 500 !important;
  outline: none;
  border-radius: 0.03rem !important;
  color: #181717 !important;
  border: 1px solid #bdbdbd !important;

  &:focus {
    border: 1px solid #484848 !important;
  }
  &::placeholder {
    opacity: 1;
    transition: all 0.2s;
  }
  &:placeholder-shown::placeholder {
    opacity: 0;
  }

  &[type='radio'] {
    border-radius: 0.03rem;
    border: solid 0.01rem #bdbdbd;
    background-color: map-get($colors, 'white');
    margin-left: 0;
    &:after {
      content: '';
      position: absolute;
      display: inline-block;
      width: 0.18rem;
      height: 0.18rem;
      border: solid 0.02rem #cacbcb;
      background-color: map-get($colors, 'white');
      top: 50%;
      transform: translateY(-50%);
      right: 0.14rem;
      border-radius: 50%;
    }
    &:focus {
      border: 1px solid #bdbdbd !important;
    }
    &:checked {
      &:after {
        border: solid 1px #292929;
      }
      &:before {
        content: '';
        position: absolute;
        display: inline-block;
        width: 0.1rem;
        height: 0.1rem;
        border-radius: 50%;
        background-color: map-get($colors, 'default');
        right: 1.1rem;
        top: 1.1rem;
        z-index: 3;
      }
    }
  }
}

.c-input__loader-container {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  color: map-get($colors, 'default');
  background: rgba(255, 255, 255, 0.8);
}

.c-input--error {
  .c-input__input {
    border-color: #df0000 !important;
  }
}

.c-input__error-text {
  @include typography('b2', 'mediums');
  text-align: left;
  margin-top: 0.08rem;
  margin-left: 0.18rem;
  color: map-get($colors, 'red_error');
  position: absolute;
}

.c-input--success {
  .c-input__input {
    border-color: map-get($colors, 'default-darken') !important;
  }
}

.c-input__label {
  font-size: 0.11rem !important;
  line-height: 0.11rem;
  position: absolute;
  left: 0.15rem;
  top: 0.06rem !important;
  cursor: text;
  opacity: 1;
  font-size: 0.1rem;
  color: #6f6f6f !important;
  line-height: 0.11rem;
  transition: all 0.2s;

  &.radio {
    font-size: 0.16rem !important;
    top: 0.12rem !important;
    font-weight: 500;
    color: #181717 !important;
    display: flex;
    flex-flow: row wrap;
    align-items: center;

    svg {
      margin-right: 0.17rem;
    }
  }

  html.smartphone & {
    left: 0.13rem !important;
  }
}

.c-input__input:placeholder-shown:not(:focus) + * {
  font-size: 0.16rem !important;
  opacity: 1;
  top: 0.17rem !important;
  left: 0.13rem !important;

  html.smartphone & {
    top: 0.13rem !important;
  }
}

.c-input-group__message {
  font-size: 0.11rem;
  font-weight: 500;
  text-align: center;
  background-color: rgba(24, 23, 23, 0.71);
  background-color: #868686;
  padding: 0.06rem;
  color: map-get($colors, 'white');
  margin-top: 0.03rem;

  div#single-step-order & {
    text-align: left;
    color: #e32c2b;
    margin-top: 0;
    background-color: transparent;
  }

  .colored-div & {
  }
}
</style>
